// Soft-alert severity chip (SOFT-ALERT SEVERITY BATCH, 2026-07-25) - shared
// by StepAnswers.jsx (dialog titles), LineItemsEditor.jsx (per-line hover/
// pin panel) and StepLineItems.jsx (Generate-click summary dialog rows), so
// severity is always presented identically wherever it appears. Severity
// itself comes from lib/dateValidationRules.js's SOFT_ALERT_SEVERITY - this
// component only owns the visual mapping (text + color, never color alone).
//
// 2026-07-26: LOW renders NO chip - it still exists in the severity map for
// ordering purposes (SAPT sorts/chains last), but is presented as a plain
// amber dialog with just the rule-code suffix, no visual chip at all.
const SEVERITY_STYLES = {
  HIGH: 'bg-orange-100 text-orange-800 border border-orange-300',
  MEDIUM: 'bg-amber-100 text-amber-800 border border-amber-300',
};

const SEVERITY_LABELS = {
  HIGH: 'HIGH TIMING RISK',
  MEDIUM: 'MEDIUM',
};

const SeverityChip = ({ severity, className = '' }) => {
  if (!severity || !SEVERITY_STYLES[severity]) return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide whitespace-nowrap ${SEVERITY_STYLES[severity]} ${className}`}
      data-testid={`severity-chip-${severity}`}
    >
      {SEVERITY_LABELS[severity]}
    </span>
  );
};

export default SeverityChip;
